// extracted by mini-css-extract-plugin
export default {"cardImg":"ScanCard_cardImg__x7-Xg","violateText":"ScanCard_violateText__YgJFB"};